(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kh-best-seller-scroll')) {
  customElements.define('kh-best-seller-scroll', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.start());
    }

    start() {
      if (!this.isConnected || this.abort) return;
      this.pin = this.querySelector('.kh-bs-pin');
      this.viewport = this.querySelector('.kh-bs-viewport');
      this.track = this.querySelector('.kh-bs-track');
      this.dots = Array.from(this.querySelectorAll('.kh-bs-dot'));
      this.filledCount = 0;
      this.dots.forEach(dot => dot.classList.remove('is-filled'));
      this.header = document.querySelector('header-component[sticky]');
      if (!this.pin || !this.viewport || !this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      window.addEventListener('scroll', schedule, { passive: true, signal });
      // Native swiping also updates the dots, including reduced-motion mode.
      this.viewport.addEventListener('scroll', () => {
        if (this.dotFrame) return;
        this.dotFrame = requestAnimationFrame(() => {
          this.dotFrame = 0;
          this.paintDots(this.viewport.scrollLeft);
        });
      }, { passive: true, signal });
      window.addEventListener('resize', () => this.measure(), { signal });
      this.motion.addEventListener('change', () => this.measure(), { signal });
      this.addEventListener('load', () => this.measure(), { capture: true, signal });
      this.querySelector('.kh-bs-skip').addEventListener('click', () => {
        const next = this.closest('.shopify-section')?.nextElementSibling;
        if (next) {
          next.setAttribute('tabindex', '-1');
          next.focus({ preventScroll: true });
          next.addEventListener('blur', () => next.removeAttribute('tabindex'), { once: true });
        }
        window.scrollTo({ top: window.scrollY + this.getBoundingClientRect().bottom - this.top, behavior: 'instant' });
      }, { signal });
      // Keep a focused product visible when navigating by keyboard.
      this.viewport.addEventListener('focusin', event => {
        if (!this.active || !event.target.matches(':focus-visible')) return;
        const item = event.target.closest('.resource-list__item');
        if (!item) return;
        const x = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        const target = Math.max(0, Math.min(this.distance, x));
        const start = window.scrollY + this.getBoundingClientRect().top - this.top;
        window.scrollTo({ top: start + target, behavior: 'instant' });
        cancelAnimationFrame(this.smoothFrame);
        this.smoothFrame = 0;
        this.targetX = target;
        this.viewport.scrollLeft = target;
        this.paintDots(target);
      }, { signal });
      this.viewport.addEventListener('keydown', event => {
        if (!this.active || event.target !== this.viewport) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const step = this.track.firstElementChild?.getBoundingClientRect().width || 200;
        let target = this.viewport.scrollLeft + (event.key === 'ArrowLeft' ? -step : step);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.distance;
        const start = window.scrollY + this.getBoundingClientRect().top - this.top;
        window.scrollTo({ top: start + Math.max(0, Math.min(this.distance, target)), behavior: 'instant' });
      }, { signal });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.pin);
      this.observer.observe(this.viewport);
      if (this.header) this.observer.observe(this.header);
      this.measure();
    }

    measure() {
      if (!this.isConnected) return;
      const headerOffset = Math.ceil(this.header?.getBoundingClientRect().height || 0) + 8;
      this.distance = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      // Measure with the active controls visible to avoid a resize feedback loop.
      this.setAttribute('data-pinned', '');
      const height = this.pin.getBoundingClientRect().height;
      // Tall cards must not disable the effect on phones. Let the section
      // scroll up until its bottom fits, then pin it for the horizontal journey.
      this.top = Math.min(headerOffset, document.documentElement.clientHeight - height - 8);
      this.style.setProperty('--kh-bs-top', `${this.top}px`);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      this.active = this.distance > 1 && (isMobile || !this.motion.matches);
      this.toggleAttribute('data-pinned', this.active);
      this.style.height = this.active ? `${height + this.distance}px` : '';
      this.update();
      if (!this.active) this.paintDots(this.viewport.scrollLeft);
    }

    update() {
      if (!this.active) {
        cancelAnimationFrame(this.smoothFrame);
        this.smoothFrame = 0;
        return;
      }

      this.targetX = Math.max(
        0,
        Math.min(this.distance, this.top - this.getBoundingClientRect().top)
      );
      if (this.smoothFrame) return;

      // Preserve fractional progress for smooth movement on mobile browsers.
      let position = this.viewport.scrollLeft;
      let lastTime = performance.now();

      const animate = (now) => {
        this.smoothFrame = 0;
        if (!this.active || !this.isConnected) return;

        const elapsed = Math.max(0, Math.min(now - lastTime, 64));
        lastTime = now;
        // Glide duration: 60 = tighter, 80 = balanced, 120 = softer.
        const easing = 1 - Math.exp(-elapsed / 80);
        const difference = this.targetX - position;

        if (Math.abs(difference) < 0.5) {
          this.viewport.scrollLeft = this.targetX;
          this.paintDots(this.targetX);
          return;
        }

        position += difference * easing;
        this.viewport.scrollLeft = position;
        this.paintDots(position);
        this.smoothFrame = requestAnimationFrame(animate);
      };

      this.smoothFrame = requestAnimationFrame(animate);
    }

    paintDots(x) {
      const ratio = this.distance <= 1 ? 1 : Math.max(0, Math.min(1, x / this.distance));
      const count = Math.floor(ratio * this.dots.length + 0.000001);
      if (count === this.filledCount) return;
      // Change only dots that crossed a step; no per-frame color animation.
      for (let i = Math.min(count, this.filledCount); i < Math.max(count, this.filledCount); i++) {
        this.dots[i].classList.toggle('is-filled', i < count);
      }
      this.filledCount = count;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.dotFrame);
      cancelAnimationFrame(this.smoothFrame);
      this.smoothFrame = 0;
      this.dotFrame = 0;
      this.frame = 0;
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'recently_viewed_handles';
    var MAX_STORED = 10;

    var root = document.querySelector('[data-recently-viewed]');
    if (!root) return;

    var max = parseInt(root.dataset.max, 10) || 4;
    var current = root.dataset.current;
    var currency = root.dataset.currency;
    var list = root.querySelector('.recently-viewed__list');

    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      stored = [];
    }
    if (!Array.isArray(stored)) stored = [];

    // Record this view on product pages only
    if (current) {
      var updated = [current].concat(stored.filter(function (h) { return h !== current; }));
      try {
        localStorage.setItem(KEY, JSON.stringify(updated.slice(0, MAX_STORED)));
      } catch (e) {}
    }

    // Show previous views, not the current product
    var handles = stored
      .filter(function (h) { return h !== current; })
      .slice(0, max);
    if (!handles.length) return;

    var formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });

    Promise.allSettled(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; });
    })).then(function (results) {
      results.forEach(function (result) {
        var p = result.status === 'fulfilled' ? result.value : null;
        if (!p) return; // skip deleted or unpublished products

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'recently-viewed__link';
        a.href = p.url;

        if (p.featured_image) {
          var img = document.createElement('img');
          img.className = 'recently-viewed__image';
          img.src = p.featured_image;
          img.alt = p.title;
          img.loading = 'lazy';
          a.appendChild(img);
        }

        var title = document.createElement('p');
        title.className = 'recently-viewed__title';
        title.textContent = p.title;
        a.appendChild(title);

        var price = document.createElement('p');
        price.className = 'recently-viewed__price';
        // The .js endpoint returns price in minor units (cents)
        price.textContent = formatter.format(p.price / 100);
        a.appendChild(price);

        li.appendChild(a);
        list.appendChild(li);
      });

      if (list.children.length) root.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
